export const ROUTE_ID = ':id';

export enum AppRoute {
  MAIN_PAGE = '/',
  LOT_PAGE = '/lot/:id',
  MAP_VIEW_PAGE = '/mapview',
  RESERVATION_PAGE = '/reservation',
}
